import { tierBorderClasses } from "../Constants/constant";
export function getBorderClass(tier) {
    return tierBorderClasses[tier] || "";
}
